// removed by extract-text-webpack-plugin
module.exports = {"large":"1600px","desktop":"1366px","ipad":"1024px","ipad-portrait":"768px","mobile-l":"640px","mobile-s":"320px","white":"#ffffff","dark-purple":"#4a2e5e","dark-red":"#a30000","dark-green":"#008300","background-grey":"#f6f6f6","light-purple":"#a096c8","wrapper":"_1I3cGxtQAGaAfrrg_zkxoW","container":"_2fd6KpL3EhRQ2kPMVUKeYe","title":"_1sARZk4OAe7Rn5qiDxrmDV","v2":"N9vS7DdpdygX-yXkam6NL","description":"_2NHs1yVPaI2D2LU--NdClX","link":"_1175w90em5UodNa7GI4wYo"};


//////////////////
// WEBPACK FOOTER
// ./src/uis/components/Hotspots/Landing/HotspotB/HotspotB.css
// module id = 1465
// module chunks = 0